export default {
    setSelectMemberId(memberId) {
        localStorage.setItem('memberId', memberId);
    },

    getSelectMemberId() {
        return localStorage.getItem('memberId');
    }
}